<template>
  <AppUsp
    :items="items"
    :usp-direction="configData.Direction ?? 'row'"
  ></AppUsp>
</template>

<script lang="ts" setup>
import { markup_markdownLikeTextToHtmlString } from '~/utils/markup/allTextTransformations';

type Item = {
  Icon: string;
  Label: string;
  SubLabel?: string;
};

interface Props {
  configData: {
    Items?: Item[];
    Direction?: string;
  };
}

const props = defineProps<Props>();

const items = computed(() => {
  let formattedItems: Item[] = [];

  if (props.configData?.Items && props.configData?.Items.length > 0) {
    formattedItems = props.configData?.Items.map((item) => {
      let label = item.Label;
      let subLabel = item.SubLabel;
      const icon = item.Icon;

      label = markup_markdownLikeTextToHtmlString(label);
      subLabel = markup_markdownLikeTextToHtmlString(subLabel);

      return {
        Label: label,
        SubLabel: subLabel,
        Icon: icon,
      };
    });
  }

  return formattedItems;
});
</script>

<style scoped></style>
